<div class="dbk-main">
  <app-top-navigation></app-top-navigation>
  <div>
    <ng-content></ng-content>
  </div>
</div>
